{
  "labels": {
    "textSingleLine": "Texto - Linha única",
    "textMultipleLines": "Texto - Múltiplas linhas",
    "date": "Data",
    "trueFalse": "Verdadeiro/Falso",
    "singleDocument": "Documento único",
    "multiDocument": "Múltiplos documentos",
    "number": "Número",
    "eMail": "E-mail",
    "phone": "Telefone",
    "dropDownSingleSelectList": "Lista suspensa de seleção única",
    "dropDownMultiSelectList": "Lista suspensa de seleção múltipla",
    "comboBox": "Caixa combinada",
    "timestamp": "Carimbo de data/hora",
    "featureLink": "Link de funcionalidade"
  },
  "descriptions": {
    "openTextFieldSingleLine": "Campo de texto aberto, uma linha",
    "openTextFieldMultipleLines": "Campo de texto aberto, várias linhas",
    "formatMmDdYyyy": "Formato MM/DD/AAAA",
    "toggleButton": "Botão de alternância",
    "singleFileUploadField": "Campo de upload de arquivo único",
    "multipleFileUploadField": "Campo de upload de múltiplos arquivos",
    "numericInputField": "Campo de entrada numérica",
    "emailAddressInputField": "Campo de entrada de e-mail",
    "format1XxxXxxXxxx": "Formato +1(XXX) XXX-XXXX",
    "selectOneOptionFromAList": "Selecione uma opção da lista",
    "selectMultipleOptionsFromAList": "Selecione várias opções da lista",
    "singleOptionDropDownListOpenTextField": "Lista suspensa de uma opção + campo de texto aberto",
    "dateAndTimeFields": "Campos de data e hora",
    "linkToTheFormFeatures": "Link para as funcionalidades do formulário"
  }
}
